var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.isNew)?_c('wallets-new',{attrs:{"connections":_vm.connections},on:{"toggleUi":function($event){_vm.isNew = $event}}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }